import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateBlogInfo } from "../features/buttonAction/buttonActionSlice";

export default function ActionButton({ blog }) {
  const dispatch = useDispatch();
  // const [blogInfo, setBlogInfo] = useState(blog);

  function likeHandler() {
    const obj = { ...blog, likes: blog.likes + 1 };
    dispatch(updateBlogInfo(obj));
  }

  function saveHandler() {
    const obj = { ...blog, isSaved: !blog.isSaved };
    dispatch(updateBlogInfo(obj));
  }
  return (
    <div className="btn-group">
      <button onClick={likeHandler} className="like-btn" id="lws-singleLinks">
        <i className="fa-regular fa-thumbs-up"></i> {blog.likes}
      </button>

      <button
        onClick={saveHandler}
        className="active save-btn"
        id="lws-singleSavedBtn"
      >
        {blog.isSaved ? (
          <>
            <i className="fa-regular active fa-bookmark"></i> Saved
          </>
        ) : (
          <>
            <i className="fa-regular fa-bookmark"></i> Save
          </>
        )}
      </button>
    </div>
  );
}
